/* eslint-disable no-undef */
/* eslint-disable no-alert */
import React from "react";
import PropTypes from "prop-types";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";
import { theme } from "@domestika-dev/prudencio/dist/theme";
import {
  FontHeavy,
  ImageHeavy,
  PlayCircleHeavy,
  Arrange,
} from "@domestika-dev/prudencio/dist/atoms/Icons";
import { useIntl } from "react-intl";

export const ContentItemMenu = ({
  addContentItem,
  canOrganize,
  organizeAction,
  marginTop,
  reference,
}) => {
  const intl = useIntl();

  const MenuContentItemOptions = [
    {
      id: "text",
      label: intl.formatMessage({ id: "projects.new.more_content_section.text.button" }),
      icon: <FontHeavy />,
      action: () => {
        addContentItem("text");
      },
      disabled: false,
    },
    {
      id: "s3image",
      label: intl.formatMessage({ id: "projects.new.more_content_section.image.button" }),
      icon: <ImageHeavy />,
      action: () => {
        addContentItem("s3image");
      },
      disabled: false,
    },
    {
      id: "embed",
      label: intl.formatMessage({ id: "projects.new.more_content_section.video.button" }),
      icon: <PlayCircleHeavy />,
      action: () => {
        addContentItem("embed");
      },
      disabled: false,
    },
    {
      id: "sort",
      label: intl.formatMessage({ id: "projects.new.more_content_section.organize.button" }),
      icon: <Arrange />,
      action: () => {
        organizeAction();
      },
      disabled: !canOrganize,
    },
  ];

  return (
    <div
      {...{ "data-label": "project-content-items-menu" }}
      style={{ marginTop: theme.space[marginTop] }}
      ref={reference}
    >
      <Form.MenuContentItem options={MenuContentItemOptions} />
    </div>
  );
};

ContentItemMenu.propTypes = {
  addContentItem: PropTypes.func,
  organizeAction: PropTypes.func,
  canOrganize: PropTypes.bool,
  marginTop: PropTypes.number,
  reference: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

ContentItemMenu.defaultProps = {
  addContentItem: () => {},
  organizeAction: () => {},
  canOrganize: false,
  marginTop: 0,
  reference: () => {},
};

export default ContentItemMenu;
